<template>
    <div>
        <div class="mb-4 text-right">
            <button type="button" class="btn btn-primary" @click="startEdit(null)">
                New connection
            </button>
        </div>
        <div style="max-height: calc(100vh - 220px);overflow-y: auto;overflow-x: hidden;">
            <transition-group name="slide-right" tag="p" @leave="transitioningDone()">
                <div class="card card-default card-default mb-2"
                     v-for="connection in connections"
                     :key="connection.id">
                    <div class="card-header d-flex pb-1">
                        <p class="text-dark">
                            <small class="text-muted">
                                Campaign: {{ connection.campaign_name }}
                            </small>
                        </p>
                        <div class="ml-auto" v-if="showSyncNow">
                            <div v-if="syncNowList.length > 0 && syncNowList.includes(connection.id)" class="alert alert-info">
                                <span><small>*Sync on this connection has been submitted, check logs for update</small></span>
                            </div>
                            <div v-else>
                            <button class="btn btn-primary" @click="syncNow(connection)"> <i class="fa fa-sync"></i> Sync Integration Now</button>
                            </div>
                        </div>
                        <div class="ml-auto">
                            <button title="Logs"
                                    type="button"
                                    class="btn btn-default btn-sm btn-icon ml-1"
                                    @click="loadLogs(connection)">
                                <i class="fa fa-fw fa-history"></i>
                            </button>
                            <button title="Edit"
                                    type="button"
                                    class="btn btn-default btn-sm btn-icon ml-1"
                                    @click="startEdit(connection)">
                                <i class="fa fa-fw fa-pencil-alt"></i>
                            </button>
                            <button title="Delete"
                                    type="button"
                                    class="btn btn-default btn-sm btn-icon ml-1"
                                    @click="(evt) => {remove(connection, evt)}">
                                <i class="fa fa-fw fa-trash"></i>
                            </button>
                        </div>
                    </div>
                    <div class="card-body p-1">
                        <div class="text-right pr-2">
                            <small class="font-italic text-muted">
                                Last Synced at:
                                {{ connection.last_synced_at || 'not synced'}}
                            </small>
                        </div>
                    </div>
                </div>
            </transition-group>
        </div>
        <transition name="fade">
            <div v-if="empty" class="card card-default m-0 p-3 empty-placeholder"
                 @click="startEdit(null)">
                <div class="card-body text-center" title="Add new connection">
                    <i class="fa fa-plus" style="font-size: 1.285rem;"></i>
                    <div>Add your first connection</div>
                </div>
            </div>
        </transition>
    </div>
</template>
<script>
    import axios from 'axios';

    export default {
        props     : {
            location: {required: true},
            integrationType: {required: true},
            refreshConnectionList: {required: true, default: false},
            showSyncNow: {required:false, default: false},
            syncNowList: {required: false}
        },
        mounted(){
            this.getConnections();
        },
        data      : () => ({
            form: new Form({}),
            loading: false,
            transitioning: false,
            selectedConnection: null,
            connections: [],
        }),
        watch     : {
            refreshConnectionList: {
                immediate: true,
                handler() {
                    this.getConnections();
                }
            }
        },
        computed: {
            empty() {
                return !this.connections.length && !this.transitioning;
            },
        },
        methods: {
            startEdit(connection) {
                this.$emit('startEditMode', connection);
            },
            exitEdit() {
                this.$emit('exitEditMode');
            },
            async loadLogs(connection) {
                this.selectedConnection = connection;
                this.$emit('loadLogs', connection);
            },
            async transitioningDone() {
                setTimeout(() => {
                    this.transitioning = false
                }, 500);
            },

            async remove(connection, evt) {
                evt.target.parentElement.blur();
                const result = await this.$confirmDialog();
                if (!result) return;
                try {
                    await this.$http.delete(this.integrationType + '/removeIntegration/' + connection.id);
                    const index = this.connections.findIndex(c => c.id === connection.id);
                    this.transitioning = true;
                    this.connections.splice(index, 1);
                    swal.close();
                } catch (e) {
                    console.error('Unable to delete' + this.integrationType + 'connection!', e);
                    if (!e.response) {
                        swal.fire("Operation failed!", e.message, "error");
                        return;
                    }

                    const response = e.response;
                    if (response.status === 500) {
                        swal.fire("Operation failed!",
                            'Sorry, an unexpected condition was encountered. Please try again later. ' +
                            'If the problem persists, please contact customer support.',
                            "error");
                        return;
                    }

                    swal.fire("Operation failed!", response.data.message, "error");
                }
            },

            async getConnections() {
                await this.$http.get(`${this.integrationType}/${this.location.id}/getIntegrations`).then(({data}) => {
                    if(typeof data.data !== 'undefined' && data.data.length){
                        this.connections = data.data;
                    }
                }).catch(error => console.error(error));
                this.loading = false;
            },
            syncNow(connection){
                this.$emit('syncNow', connection);
            }
        }
    }
</script>
